import { render } from "./ProductsTableView.vue?vue&type=template&id=5ca24d35&scoped=true"
import script from "./ProductsTableView.vue?vue&type=script&lang=js"
export * from "./ProductsTableView.vue?vue&type=script&lang=js"

import "./ProductsTableView.vue?vue&type=style&index=0&id=5ca24d35&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca24d35"]])

export default __exports__